import { useCallback, useMemo } from 'react';
import { Module, ScopeEnum } from 'src/domain';
import { StoreInventoryRow } from 'src/domain/table/store-inventory.row';
import { useChainId } from 'src/hooks/chain';
import { useUnsavedChangesModule } from 'src/hooks/unsaved-changes';

export const useStoreInventoryUnsavedChanges = () => {
    const chainId = useChainId();
    const [unsavedChangesRaw, setUnsavedChangesRaw] = useUnsavedChangesModule<[number, Partial<StoreInventoryRow>][]>(
        Module.StoreInventoryManagement,
        ScopeEnum.GLOBAL,
        chainId ?? undefined
    );
    const unsavedChanges = useMemo(() => new Map(unsavedChangesRaw), [unsavedChangesRaw]);
    const setUnsavedChanges = useCallback(
        (changes: Map<number, Partial<StoreInventoryRow>>) => {
            setUnsavedChangesRaw(Array.from(changes.entries()));
        },
        [setUnsavedChangesRaw]
    );
    return [unsavedChanges, setUnsavedChanges] as const;
};
